/*Content Filters*/
import Linkify from './Linkify';
import Stickerify from './Stickerify';
import Hashtagify from './Hashtagify';
import FeedHashtagify from './FeedHashtagify';

class Filters {

    constructor(){
        this.filterArr = {
            linkify: Linkify,
            stickerify: Stickerify,
            hashtagify: Hashtagify,
            feedhashtagify: FeedHashtagify
        };
    }

    process(filters=[], contentStr){
        for(const i in filters){
            contentStr = this.filterArr[filters[i]](contentStr);
        }
        return contentStr;
    }

}

export default (new Filters);